module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/hospital/hospital.component.css
// module id = ./src/app/Pages/manage/hospital/hospital.component.css
// module chunks = main